import { Link, useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react'
import config from '../../../../config'
import 'bootstrap/dist/css/bootstrap.min.css';
import Connectwallet from '../Connectwallet';
import { Button, Container, Form, Nav, Navbar, Offcanvas, Modal, Row, Col, NavDropdown, Accordion } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import * as ACTIONTYPES from '../../../../redux/actionTypes'
import { useDisconnect } from 'wagmi';


const Presaleheader = (props) => {
  const { setOpenBuyForm } = props;
  const _useDisconnect = useDisconnect();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  //  const loginDetails = useSelector((state) => state.auth.LoginDetails);
  const walletConnnected = useSelector((state) => state.auth.walletConnnected);
  //  const [LoginData, setLoginData] = useState([]);
  const [WalletAddress, setWalletAddress] = useState("")
  const [show, setShow] = useState(false);
  const [connectWalletNow, setconnectWalletNow] = useState(false);
  const handleClose = () => {
    setShow(false);
    if (props?.setconnectWalletNow) {
      props?.setconnectWalletNow(false)
    }
  }
  //console.log({ walletConnnected })
  // useEffect(() => {
  //   setLoginData(loginDetails)
  // }, [loginDetails])

  // useEffect(() => {
  //   if (props?.isLogout) {
  //     LogOut()
  //   }
  // }, [props?.isLogout])

  useEffect(() => {
    setShow(connectWalletNow)
  }, [connectWalletNow])

  useEffect(() => {
    setWalletAddress(walletConnnected);
    if (props?.setconnectWalletNow) {
      props?.setconnectWalletNow(false)
    }
    setShow(false)
  }, [walletConnnected])

  // const LogOut = () => {
  //   dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
  //   dispatch({ type: ACTIONTYPES.USERLOGIN, payload: [], token: [] });
  //   navigate(`${config.baseurl}`);
  // }

  const buyToken = () => {
    if (WalletAddress) {
      setOpenBuyForm(true)
    } else {
      setShow(true);
    }
  }

  const connectWallet = async () => {
    setconnectWalletNow(true)
  }

  const disconnectWallet = () => {
    _useDisconnect.disconnect()
    dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
  }
  const [isSticky, setIsSticky] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <div className={`${props?.presaleheader ? 'presaleheader' : 'headerico'} ${isSticky && !props?.presaleheader ? 'sticky' : ''}`}>
      {['xl'].map((expand) => (
        <Navbar key={expand} expand={expand} className="mb-3 mt-3" >
          <Container>
            <Navbar.Brand href="#" className='text-white'><img src='assets/images/logo/logo.svg' alt='' width="170px" /></Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton >
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  <img src='assets/images/logo/logo.svg' alt='' width={`170px`} />
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-center flex-grow-1 pe-3">
                  {/* <Nav.Link href={`${config.baseurl}Aboutus`} >About Us</Nav.Link>
                  <Nav.Link href="#FAQ">FAQs</Nav.Link> */}
                  {/* <Nav.Link href={`${config.baseurl}blog`} >Blog </Nav.Link> */}
                  {/* <li><a href={} target="_blank" className='text-decoration-none '>Blog</a></li> */}
                </Nav>
                <Form className="d-xl-flex align-items-center gap-4">
                
                <NavDropdown
                        title="Quick Links"
                        id="basic-nav-dropdown"
                        className="headerDropdown"
                      >
                        {/* <div className="d-head mb-2">INFI Hub</div> */}
                        <div className="p-3">
                          <Accordion defaultActiveKey="0" alwaysOpen>
                            <NavDropdown.Item
                              href='https://launchpad.infimultichain.com/'
                              target="_blank" rel="noreferrer noopener"
                              className="mb-2 active"
                            >
                              <div className="d-flex align-items-center">
                                <div>
                                  <img
                                    src="assets/images/dashboard/icon/home.svg"
                                    className=""
                                    alt=""
                                  />
                                </div>
                                <div>INFI HUB</div>
                              </div>
                            </NavDropdown.Item>

                            <Accordion.Item eventKey="1" className="mb-2">
                              <Accordion.Header>
                                {" "}
                                <img
                                  src="assets/images/dashboard/icon/swap.svg"
                                  className=""
                                  alt=""
                                />
                                INFI Main
                              </Accordion.Header>
                              <Accordion.Body className="p-0">
                                <NavDropdown.Item href="https://infimultichain.com/app/simplestaking" target="_blank" rel="noreferrer noopener">
                                  Staking
                                </NavDropdown.Item>
                                <NavDropdown.Item href="https://infimultichain.com/app/dashboard" target="_blank" rel="noreferrer noopener">
                                  SbSe Pools
                                </NavDropdown.Item>
                                <NavDropdown.Item href="#action/3.3">
                                  Profits
                                </NavDropdown.Item>
                              </Accordion.Body>
                            </Accordion.Item>
                            <NavDropdown.Item
                              href={"https://infimultichain.com/ico/"}
                              target="_blank"
                              rel="noreferrer noopener"
                              className="mb-2"
                            >
                              <img
                                src="assets/images/dashboard/icon/ico.svg"
                                className=""
                                width={`22px`}
                                alt=""
                              />{" "}
                              INFI ICO
                            </NavDropdown.Item>
                            <Accordion.Item eventKey="2" className="mb-2">
                              <Accordion.Header>
                                {" "}
                                <img
                                  src="assets/images/dashboard/icon/launchpad.svg"
                                  className=""
                                  alt=""
                                />
                                INFI Launchpad
                              </Accordion.Header>
                              <Accordion.Body className="p-0">
                                <NavDropdown.Item href={`https://launchpad.infimultichain.com/launchpad`} target="_blank" rel="noreferrer noopener">
                                  Launchpad Home
                                </NavDropdown.Item>
                                <NavDropdown.Item href={`https://launchpad.infimultichain.com/launchpad#activepresale`} target="_blank" rel="noreferrer noopener">
                                  Active ICO's
                                </NavDropdown.Item>
                                <NavDropdown.Item href={`https://launchpad.infimultichain.com/launchpad#listed`} target="_blank" rel="noreferrer noopener">
                                  Listed
                                </NavDropdown.Item>
                              </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3" className="">
                              <Accordion.Header>
                                {" "}
                                <img
                                  src="assets/images/dashboard/icon/swap.svg"
                                  className=""
                                  alt=""
                                />
                                Swap
                              </Accordion.Header>
                              <Accordion.Body className="p-0">
                                <NavDropdown.Item >
                                  SbSe Order Book (soon)
                                </NavDropdown.Item>
                                <NavDropdown.Item >
                                  SbSe Instant (soon)
                                </NavDropdown.Item>
                                <NavDropdown.Item>
                                  MarketPlace (soon)
                                </NavDropdown.Item>
                                <NavDropdown.Item >
                                  INFI Hybrid eWallet (soon)
                                </NavDropdown.Item>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </div>
                      </NavDropdown>
                  
                  {/* <a href={`https://infimultichain.com/exch/`} target='_blank' rel='noreferrer noopener' className='text-decoration-none d-inline-block me-3 '>
                    <Button variant="outline-primary" className='text-uppercase fs-6'>INFI CDEX Main</Button>
                  </a>
                  <a href="https://launchpad.infimultichain.com/" target="_blank" rel="noopener noreferrer" className='text-decoration-none d-inline-block me-3'> 
                  <Button variant="outline-primary" className='text-uppercase fs-6'>Launchpad/Trade</Button>
                  </a>                       */}
                  {/* <h3 className='text-gradient'><b>{!WalletAddress ? 'CONNECT WALLET' : 'CONNECTED WALLET'}</b></h3>
                      {WalletAddress && <small className='mb-0 text-white text-break'>{WalletAddress}</small>}
                          <div className=' mt-4 mb-4'>
                          {!WalletAddress && <Button variant='primary' className='text-black w-100 mb-3 text-uppercase fs-6' onClick={connectWallet}><b>Connect Wallet</b></Button>}
                          {WalletAddress && <Button onClick={disconnectWallet} variant='primary' className='text-black w-100 text-uppercase fs-6'><b>Disconnect</b></Button>}
                  </div> */}
                  <>
                    {/* <a href={`${config.baseurl}login`} className='text-decoration-none d-inline-block '>
                        <Button variant="outline-primary" className='text-uppercase fs-6 me-3'>Login</Button>
                      </a> */}
                    {/* <a href={`${config.baseurl}signup`} className='text-decoration-none d-inline-block '>
                        <Button variant="outline-primary" className='text-uppercase fs-6'>Register</Button>
                      </a> */}
                  </>
                  <>
                    {!WalletAddress && <Button variant="outline-primary" className='text-uppercase fs-6 px-4 me-3 d-inline-block' onClick={() => setShow(true)}>Connect wallet</Button>}
                    {WalletAddress && <Button variant="outline-primary" className='text-uppercase fs-6 me-3 d-inline-block '>{WalletAddress.toString().substring(0, 6) + '...' + WalletAddress.toString().substr(WalletAddress.length - 6)}</Button>}
                    {WalletAddress && <Button onClick={() => disconnectWallet()} variant="outline-primary" className='text-uppercase fs-6 me-3 d-inline-block '>Disconnect</Button>}
                    {/* <Button variant="primary" className='text-uppercase fs-6 me-3 d-inline-block text-black ' onClick={buyToken}>Buy Now</Button> */}
                    {WalletAddress && <Button variant="primary" className='text-uppercase fs-6  px-4 d-inline-block text-black' onClick={() => navigate(`${config.baseurl}dashboard`)}>Dashboard</Button>}</>
                  {/* <Button onClick={() => LogOut()} variant="outline-primary" className='text-uppercase fs-6 d-inline-block'>Logout</Button> */}
                  {/* -----Connect Wallet----- */}
                  {/* <Modal show={show} onHide={handleClose} centered>
                    <Modal.Header closeButton>
                      <Modal.Title></Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='text-center'>
                      <Row className="justify-content-center">
                        <Col lg={8}>
                          <Connectwallet loginDetails={loginDetails} />
                        </Col>
                      </Row>

                    </Modal.Body>
                    <Modal.Footer>

                    </Modal.Footer>
                  </Modal> */}
                  <Connectwallet show={show} onHide={handleClose} />
                  {/* ------------- */}
                </Form>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </div>
  );
}

export default Presaleheader